import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';
import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import { css } from '@emotion/core';

import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';

const PageTemplate = css`
  .site-main {
    background: #ececec;
    padding-bottom: 4vw;
  }
`;

const About: React.FC = () => (
  <IndexLayout>
    <Helmet>
      <title>About</title>
    </Helmet>
    <Wrapper css={PageTemplate}>
      <header css={[outer, SiteHeader]}>
        <div css={inner}>
          <SiteNav isTag  />
        </div>
      </header>
      <main id="site-main" className="site-main" css={[SiteMain, outer]}>
        <article className="post page" css={[PostFull, NoImage]}>
          <PostFullHeader>
            <PostFullTitle>About</PostFullTitle>
          </PostFullHeader>

          <PostFullContent className="post-full-content">
            <div className="post-content">
              <p>
                Hello!!! Let me me introduce myself. I am Amlan. I am a Cloud Architect by profession. I love learning new technologies and applying them on my weekend side projects.
                We all have our own side projects right? Me too and I love to keep applying new technologies. In this blog I try to
                share what I learn so it can help someone learn new topics too.
              </p>
              <p>
                I know what areas I struggle or struggled while learning new topics. Through my posts I cover those topics so someone
                else can learn from those too. In this blog you will find a little bit of this and little bit of that. I will be writing
                about cloud technologies like AWS. Along with that you will also find me exploring solutions related to Devops technologies
                like Docker/CHEF/Jenkins in addition to custom solutions using Python, NodeJS etc. If I start listing out the items, the listing
                will be endless so I will let my posts do the talking.
                Hope I am able to spread some knowledge with what I keep learning.
              </p>
              <b>What powers my Blog?</b>
              <p>
                This blog is built on Gatsby. I customized a <a href='https://www.gatsbyjs.org/starters/scttcper/gatsby-casper/' target='_blank'>Gatsby starter</a> by <a href='https://github.com/scttcper' target='_blank'>scttcper
                </a>. The static files are generated from Gatsby and hosted on Netlify. I will be writing a whole post explaining my flow.
              </p>
              <b>How To Reach me?</b>
              <p>
                Here are the ways to reach me: <br/>
                <a href='https://medium.com/@amlana21' target="_blank">Medium </a><br/>
                <a href='https://www.linkedin.com/in/amlan-chakladar-40339525/' target="_blank">LinkedIn </a><br/>
                <a href='https://github.com/amlana21' target="_blank">GitHub </a><br/>
                <a href='https://twitter.com/amlana24' target="_blank">Twitter </a><br/>
                <a href='mailto:amlanc@achakladar.com' target="_blank">Email Me </a>
              </p>

              <b>License</b>
              <p>Unless otherwise specified, all my work is covered by Creative Commons Attribution 4.0 International License and <a href='/license'>MIT License</a>.  
              <a rel="license" href="http://creativecommons.org/licenses/by/4.0/"><img alt="Creative Commons License" style={{borderWidth:0}} src="https://i.creativecommons.org/l/by/4.0/88x31.png" /></a>
              </p>
              <p><a href="https://icons8.com" target='_blank'>Social icons by Icons8</a></p>
            </div>
          </PostFullContent>
        </article>
      </main>
      <Footer />
    </Wrapper>
  </IndexLayout>
);

export default About;
